import { Layout } from "../..";
import ErrorFound from '../../../CommonComponents/ErrorFound'
import Managefeeds from "../Feeds/ManageFeeds";
import DisplayThemes from "../Themes";
import AllFeeds from '../Feeds/AddFeeds/AllFeeds';
import AppsMore from '../AppsMore';
import Publish from '../Publish'; 

const WallCustomModule = ({ showAddFeed, showAppsMore, showManageFeed, showPublish, showCustomization, wallData, prefix }) => {
    return ( 
        <Layout prefix={prefix}>
            <ErrorFound> <DisplayThemes showDemoWall={wallData?.wall?.Personalization?.demoWall} errorCode={wallData?.error_code} error={wallData?.error} /> </ErrorFound>
            {showAddFeed ? (<ErrorFound> <AllFeeds />{" "} </ErrorFound>)
                : showAppsMore ? (<ErrorFound> <AppsMore customization={false} /> </ErrorFound>)
                    : showManageFeed ? (<ErrorFound> <Managefeeds /> </ErrorFound>)
                        : showCustomization ? (<ErrorFound> <AppsMore customization={true} /> </ErrorFound>)
                            : showPublish ? (<ErrorFound> <Publish /> </ErrorFound>)
                                : null}
        </Layout>
    );
};

export default WallCustomModule;